import axios from "axios";
import { Auth } from 'aws-amplify';

const axiosInstance = axios.create({
  baseURL: "",
  headers: {
    'Content-Type': 'application/json'
  },
});

axiosInstance.interceptors.request.use(async (config) => {
  try {
    const session = await Auth.currentSession();
    const idToken = session.getIdToken().getJwtToken();
    config.headers.Authorization = `Bearer ${idToken}`;
  } catch (error) {
    console.error('Error fetching auth token:', error);
  }
  return config;
});

// Function to update axios instance dynamically when config is available
export const updateAxiosConfig = (config) => {
  if (config?.BASE_URL) {
    axiosInstance.defaults.baseURL = config.BASE_URL;
    axiosInstance.defaults.headers.common['x-api-key'] = config.API_KEY;
  }
};

// Custom interceptor to delay requests until config is available
axiosInstance.interceptors.request.use(
  async (request) => {
    if (!axiosInstance.defaults.baseURL) {
      console.warn("Axios instance is not configured yet, waiting for config...");
      await new Promise((resolve) => setTimeout(resolve, 100)); // Small delay
    }
    return request;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
